import { TRootState } from "Redux/Reducers";

export const getLastEmployeeId = (state: TRootState) => state.employee.lastUpdateId;
